import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import { empty_pagination } from '../../constants/empty_pagination';
import Agent from '../agent';

const initialState = {
  loading: false,
  superAdmin: [],
  _superAdmin: [],
  // singleHedgeFund: {},
  pagination: { pages: 0 },
  errors: {},
  redirectTo: null,
  success: false,
  message: '',
};

// These are redux/toolkit async thunk for performing api call
// There methods are automatically attached to reducers and actions below
export const getSuperAdmin = createAsyncThunk(
  'superAdmin/get',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await Agent.superAdmin.get(payload);
      return data;
    } catch (err) {
      let error = err;
      if (!error.response) {
        return rejectWithValue({ errors: { [err.name]: err.message } });
      }
      return rejectWithValue(error.response.body);
    }
  }
);

export const addNewSuperAdmin = createAsyncThunk(
  'superAdmin/create',
  async (data, { rejectWithValue }) => {
    try {
      return await (
        await Agent.superAdmin.create(data)
      ).data;
    } catch (err) {
      let error = err;
      if (!error.response) {
        return rejectWithValue({ errors: { [err.name]: err.message } });
      }
      return rejectWithValue(error.response.body);
    }
  }
);

const superAdminSlice = createSlice({
  name: 'superAdmin',
  initialState,
  reducers: {
    setLoading(state) {
      state.loading = true;
    },
    updateUserState(state, action) {
      if (state.errors[action.payload.key]) delete state.errors[action.payload.key];
      state.user[action.payload.key] = action.payload.value;
    },
    setSuccess(state) {
      state.success = false;
    },
  },
  extraReducers: {
    // these are the actions generated by the above createAsyncThunk of redux/toolkit
    [getSuperAdmin.pending]: (state) => {
      state.loading = true;
      state.success = false;
    },

    [getSuperAdmin.fulfilled]: (state, action) => {
      let pagination = action?.payload?.pagination || empty_pagination;
      let data = action?.payload?.data;
      state.loading = false;
      state.success = true;
      // if (data) {
      //   state.superAdmin = pagination.currentPage > 1 ? [...state.superAdmin, ...data] : data;
      // }

      state.pagination = pagination;
      state._superAdmin[pagination.currentPage] = data;

      /**
       * Current: takes a transaction of the current state of a draft and finalizes it (but without freezing).
       */
      const superAdminArray = current(state._superAdmin);

      let sortedsuperAdminArray = [];

      /**
       * Loop through pages of object containing array of transactions.
       * FIXED: unarranged data in table list gets set when pages are not loaded serially.
       */
      for (let i = 1; i <= state?.pagination?.currentPage; i++) {
        if (superAdminArray[i]) {
          sortedsuperAdminArray = [...sortedsuperAdminArray, ...superAdminArray[i]];
        }
      }

      state.superAdmin = sortedsuperAdminArray;
    },

    [getSuperAdmin.rejected]: (state, action) => {
      state.loading = false;
      state.success = false;
      state.errors = action?.payload?.errors || {};
    },

    // Add New HedgeFund
    [addNewSuperAdmin.pending]: (state) => {
      state.loading = true;
      state.success = false;
    },

    [addNewSuperAdmin.fulfilled]: (state, action) => {
      let data = action?.payload?.data || {};
      // let pagination = action?.payload?.pagination || empty_pagination;
      state.loading = false;
      state.success = true;
      state.message = 'Admin successfully created';
      // if (data) {
      //   state.superAdmin = pagination.currentPage > 1 ? [...state.superAdmin, ...data] : data;
      // }
      state.superAdmin = [...state.superAdmin, data];
    },

    [addNewSuperAdmin.rejected]: (state, action) => {
      state.loading = false;
      state.success = false;
      state.errors = action?.payload?.message || 'Something went wrong';
    },
  },
});

export const superAdminSelector = (state) => state.superAdmin;

export const { reducer, actions } = superAdminSlice;
